import { call } from "redux-saga/effects";

let initPersonalizationModule = null;
export function* initClientPersonalizationLM({ payload }) {
  if (!initPersonalizationModule) {
    initPersonalizationModule = yield call(() => import("./init"));
  }
  yield call(initPersonalizationModule.clientPersonalization, { payload });
}
let updatePersonalizationModule = null;
export function* updateClientPersonalizationLM({ payload }) {
  if (!updatePersonalizationModule) {
    updatePersonalizationModule = yield call(() => import("./update"));
  }
  yield call(updatePersonalizationModule.updatePersonalization, { payload });
}


